<template>
	<div class="games-block __pt0">
		<div class="games-block_row" v-if="games">
			<div class="games-block_col" v-for="game in gamesPaged" :key="'game' + game.id">
				<router-link :to="{name: 'game', params: {id: game.id}}" class="games-block_item">
					<div class="games-block_image">
						<img :src="game.logo_image" alt="">
					</div>
					<div class="games-block_content">
						<div class="games-block_name">{{ game.name }}</div>
						<div class="games-block_cat" :class="['__' + game.genre_id]">{{ game.genre_name }}</div>
						<div class="games-block_text" v-html="game.description"></div>
						
						<div class="games-block_button">
							<router-link :to="{name: 'game', params: {id: game.id}}" class="button __type-2 __min">Играть</router-link>
						</div>
					</div>
				</router-link>
			</div>
		</div>
		
		<div class="games-block_page-button" v-if="gamesPaged.length < games.length">
			<a href="" class="button __type-2" @click.prevent="changePage">{{$t('Загрузить еще')}}</a>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['games'],
		
		data() {
			return {
				page: 1,
			}
		},

		computed: {
			gamesPaged() {
				let total = 9;

				return this.games.slice(0, total * this.page);
			}
		},
		
		methods: {
			changePage() {
				this.page++;
			}
		}
	}
</script>

<style scoped>

</style>
